(() => {
  if (window.kuzuMotionLoaded) return;
  window.kuzuMotionLoaded = true;

  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const stagger = '.kuzu-evidence__card, .kuzu-origin-editorial__item, .kuzu-origin-strip__item, .kuzu-ritual__step, .kuzu-journal-card, .kuzu-journal__draft-list > li, .kuzu-trace-lookup__layers > li, .kuzu-document-card, .kuzu-farmer-card';
  // Never mask interactive product galleries or transform sticky purchase panels.
  const images = '.kuzu-signature__visual, .kuzu-featured__media, .kuzu-story__media, .kuzu-source-card__media';
  const copy = '.kuzu-signature__copy > h1, .kuzu-signature__intro, .kuzu-drop__story > h2, .kuzu-drop__intro, .kuzu-editorial-heading, .kuzu-editorial-lead';
  const pending = new Set();
  let observer;
  const reveal = (section, instant = false) => {
    if (!section) return;
    if (instant) section.dataset.kuzuInstant = '';
    section.dataset.kuzuVisible = '';
    observer?.unobserve(section);
    pending.delete(section);
  };

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0 });
  }

  const prepare = (scope = document) => {
    const sections = scope.matches?.('.shopify-section')
      ? [scope] : [...scope.querySelectorAll('main .shopify-section')];
    sections.forEach((section) => {
      if (!section.closest('main') || section.dataset.kuzuReveal !== undefined) return;
      section.dataset.kuzuReveal = '';
      section.querySelectorAll(stagger).forEach((item, index) => {
        item.dataset.kuzuStaggerItem = '';
        item.style.setProperty('--kuzu-stagger-delay', Math.min(index, 5) * 65 + 'ms');
      });
      section.querySelectorAll(images).forEach((item) => { item.dataset.kuzuImageReveal = ''; });
      section.querySelectorAll(copy).forEach((item, index) => {
        item.dataset.kuzuCopyReveal = '';
        item.style.setProperty('--kuzu-copy-delay', Math.min(index, 3) * 85 + 'ms');
      });
      const instant = preference.matches || !observer || window.Shopify?.designMode;
      if (instant || section.getBoundingClientRect().top < window.innerHeight * .96) {
        // Above-fold content, including the LCP image, never waits for an entrance.
        reveal(section, true);
      } else {
        pending.add(section);
        observer.observe(section);
      }
    });
  };

  document.documentElement.classList.add('kuzu-motion-ready');
  prepare();
  document.addEventListener('focusin', (event) => reveal(event.target.closest?.('[data-kuzu-reveal]'), true));
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('shopify:section:select', (event) => reveal(event.target, true));
  document.addEventListener('shopify:section:unload', (event) => {
    observer?.unobserve(event.target);
    pending.delete(event.target);
  });
  preference.addEventListener?.('change', (event) => {
    if (event.matches) [...pending].forEach((section) => reveal(section, true));
  });
  window.addEventListener('beforeprint', () => [...pending].forEach((section) => reveal(section, true)));
})();
